import { render } from "./SeoH1.vue?vue&type=template&id=fcb6adf8"
import script from "./SeoH1.vue?vue&type=script&lang=js"
export * from "./SeoH1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__